import { memo } from "react";
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import LoadingButton from "@mui/lab/LoadingButton";
import { closePingOrder } from "features/transactions/api";
import When from "ui/support/When";
import { usePingOrder } from "./support";
import useTransactionAction from "./useTransactionAction";

const ClosePingOrder = () => {
    const {
        isLoading,
        transaction,
        request
    } = useTransactionAction();

    const { checkIfClosePingOrderAvailable } = usePingOrder(transaction);

    const onClick = () => request(() => closePingOrder({
        ...transaction,
        coreId: transaction.pingTransactionCoreId
    }), {
        shouldNotifyOnSuccess: true
    });

    return (
        <When
            if={checkIfClosePingOrderAvailable}
            then={(
                <LoadingButton
                    data-test-id="transactions.transactionActions.closePingOrder"
                    startIcon={(
                        <CloseFullscreenIcon />
                    )}
                    onClick={onClick}
                    loading={isLoading}
                    variant='outlined'
                    size='small'
                >
                    Close PING order
                </LoadingButton>
            )}
        />
    );
};

export default memo(ClosePingOrder);